export default {
  descrizione: ''
};
